//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/teleport/auth.proto (package dxos.mesh.teleport.auth, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/teleport/auth.proto.
 */
export const file_dxos_mesh_teleport_auth: GenFile = /*@__PURE__*/
  fileDesc("Ch1keG9zL21lc2gvdGVsZXBvcnQvYXV0aC5wcm90bxIXZHhvcy5tZXNoLnRlbGVwb3J0LmF1dGgiKAoTQXV0aGVudGljYXRlUmVxdWVzdBIRCgljaGFsbGVuZ2UYASABKAwiKgoUQXV0aGVudGljYXRlUmVzcG9uc2USEgoKY3JlZGVudGlhbBgBIAEoDDJ6CgtBdXRoU2VydmljZRJrCgxBdXRoZW50aWNhdGUSLC5keG9zLm1lc2gudGVsZXBvcnQuYXV0aC5BdXRoZW50aWNhdGVSZXF1ZXN0Gi0uZHhvcy5tZXNoLnRlbGVwb3J0LmF1dGguQXV0aGVudGljYXRlUmVzcG9uc2ViBnByb3RvMw");

/**
 * @generated from message dxos.mesh.teleport.auth.AuthenticateRequest
 */
export type AuthenticateRequest = Message<"dxos.mesh.teleport.auth.AuthenticateRequest"> & {
  /**
   * @generated from field: bytes challenge = 1;
   */
  challenge: Uint8Array;
};

/**
 * Describes the message dxos.mesh.teleport.auth.AuthenticateRequest.
 * Use `create(AuthenticateRequestSchema)` to create a new message.
 */
export const AuthenticateRequestSchema: GenMessage<AuthenticateRequest> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_auth, 0);

/**
 * @generated from message dxos.mesh.teleport.auth.AuthenticateResponse
 */
export type AuthenticateResponse = Message<"dxos.mesh.teleport.auth.AuthenticateResponse"> & {
  /**
   * @generated from field: bytes credential = 1;
   */
  credential: Uint8Array;
};

/**
 * Describes the message dxos.mesh.teleport.auth.AuthenticateResponse.
 * Use `create(AuthenticateResponseSchema)` to create a new message.
 */
export const AuthenticateResponseSchema: GenMessage<AuthenticateResponse> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_auth, 1);

/**
 * @generated from service dxos.mesh.teleport.auth.AuthService
 */
export const AuthService: GenService<{
  /**
   * @generated from rpc dxos.mesh.teleport.auth.AuthService.Authenticate
   */
  authenticate: {
    methodKind: "unary";
    input: typeof AuthenticateRequestSchema;
    output: typeof AuthenticateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_mesh_teleport_auth, 0);

